import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import OurSharedFuture from "./sections/OurSharedFuture";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import VCisoStrategy from "./sections/VCisoStrategy";
import TheHeritageOfHospitality from "./sections/TheHeritageOfHospitality";
import GuestTestimonials from "./sections/GuestTestimonials";
import UpcomingExperiences from "./sections/UpcomingExperiences";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <OurSharedFuture />
      <EngineeredForExcellence />
      <VCisoStrategy />
      <TheHeritageOfHospitality />
      <GuestTestimonials />
      <UpcomingExperiences />
      <Footer />
    </div>;
}